// The roof remediation process we proposed to Amazon, each step in its owner's column. Step 1
// shows it in the roof step's pane; Steps 2 and 3 open it from a link beside the roof's title,
// and Step 3 from the roof's blocker card too.
import { Fragment, useEffect, useRef, useState } from "react";

import { PartyChip } from "./PartyChip";
import { ROOF_PROCESS, type RoofProcessStep } from "./roofProcessSteps";
import styles from "./roofProcess.module.css";

const StepCard = ({ step }: { step: RoofProcessStep }) => (
  <div
    className={[
      styles.card,
      step.owner === "amazon" ? styles.ownAmazon : styles.ownInrange,
      step.ifFails ? styles.cardFails : "",
    ].join(" ")}
  >
    <div className={styles.cardHead}>
      <span className={styles.num}>{step.n}</span>
      <b>{step.title}</b>
    </div>
    <span>{step.line}</span>
  </div>
);

export const RoofProcess = () => (
  <div className={styles.wrap}>
    <div className={styles.eyebrowSmall}>Proposed by InRange · not yet agreed</div>
    <h4 className={styles.title}>Roof remediation process</h4>
    <div className={styles.lanes}>
      <div className={styles.laneHead}>
        <PartyChip owner="amazon" />
      </div>
      <div className={styles.laneHead}>
        <PartyChip owner="inrange" />
      </div>
      {ROOF_PROCESS.map((s) => (
        <Fragment key={s.n}>
          <div className={styles.laneCell}>{s.owner === "amazon" && <StepCard step={s} />}</div>
          <div className={styles.laneCell}>{s.owner === "inrange" && <StepCard step={s} />}</div>
        </Fragment>
      ))}
    </div>
    <div className={styles.callout}>
      Amazon owns the scope, the works and any further works after a failed test. We own the
      two watertight tests.
    </div>
  </div>
);

/** The roof's "not agreed" mark on Steps 2 and 3, opening the proposed process. */
export const RoofProcessLink = () => {
  const ref = useRef<HTMLDialogElement | null>(null);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const dialog = ref.current;
    if (open && dialog && !dialog.open) {
      dialog.showModal();
      // showModal focuses Close, the only control and the last thing in the pane, which
      // scrolls the pane to the bottom; it always opens at the top.
      dialog.scrollTop = 0;
    }
  }, [open]);
  return (
    <>
      <button type="button" className={styles.link} onClick={() => setOpen(true)}>
        <span aria-hidden="true">*</span> See proposed process
      </button>
      {open && (
        <dialog ref={ref} className={styles.dialog} onClose={() => setOpen(false)}>
          <RoofProcess />
          <form method="dialog" className={styles.dialogActs}>
            <button type="submit" className={styles.close}>
              Close
            </button>
          </form>
        </dialog>
      )}
    </>
  );
};

/** Step 3's programme row title for the roof, with the link on a line of its own. */
export const RoofProcessTitle = ({ title, className }: { title: string; className: string }) => (
  <span className={styles.stack}>
    <span className={className}>{title}</span>
    <RoofProcessLink />
  </span>
);
